import r from "../managers/braze-instance.js";
import { logger as E, IndexedDBAdapter as et } from "../../shared-lib/index.js";
import ot from "../triggers/models/trigger-events.js";
import { TriggersProviderFactory as rt } from "../triggers/triggers-provider-factory.js";
export function openSession() {
  if (!r.rr()) return;
  const i = r.nn();
  if (!i) return;
  i.openSession();
  const t = et.Us.Rs,
    o = new et(t, E);
  o.kr(t.Fs.vr, (r, n) => {
    const e = n.lastClick,
      s = n.trackingString;
    E.info(`Firing push click trigger from ${s} push click at ${e}`);
    const c = i.$r(e, s),
      g = function () {
        rt.o().he(ot.wr, [s], c);
      };
    i.yr(g, g), o.je(t.Fs.vr, r);
  }),
    o.Ds(t.Fs.zr, function (r) {
      i.Fr(r);
    });
}
